"use strict";

var _regeneratorRuntime = require("/var/www/dev/prosper/admin.samsung-prosper.dev.pannovate.net/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactSelect = _interopRequireDefault(require("react-select"));

var _styles = require("@material-ui/core/styles");

var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));

var _TextField = _interopRequireDefault(require("@material-ui/core/TextField"));

var _Paper = _interopRequireDefault(require("@material-ui/core/Paper"));

var _MenuItem = _interopRequireDefault(require("@material-ui/core/MenuItem"));

var _colorManipulator = require("@material-ui/core/styles/colorManipulator");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var theme = (0, _styles.createMuiTheme)({
  // For Underline Color After Click
  palette: {
    primary: {
      main: "rgba(255, 255, 255, 1)"
    }
  },
  // For Underline Hover Color
  overrides: {
    MuiInput: {
      underline: {
        '&:before': {
          borderBottom: '1px solid #ffffff!important'
        },
        '&:after': {
          borderBottom: '2px solid #0275d8!important'
        }
      },
      root: {
        // Name of the rule
        color: 'white' // Some CSS,

      }
    }
  }
});

var styles = function styles(theme) {
  return {
    root: {
      flexGrow: 1,
      // height: 240,
      color: 'white'
    },
    input: {
      display: 'flex',
      // padding: 0,
      color: 'white',
      // maxHeight: 60,
      minHeight: 30,
      fontWeight: 300
    },
    valueContainer: {
      display: 'flex',
      flexWrap: 'wrap',
      flex: 1,
      alignItems: 'center',
      color: 'white'
    },
    chip: {
      margin: "".concat(theme.spacing.unit / 2, "px ").concat(theme.spacing.unit / 4, "px")
    },
    chipFocused: {
      backgroundColor: (0, _colorManipulator.emphasize)(theme.palette.type === 'light' ? theme.palette.grey[300] : theme.palette.grey[700], 0.08)
    },
    noOptionsMessage: {
      padding: "".concat(theme.spacing.unit, "px ").concat(theme.spacing.unit * 2, "px")
    },
    singleValue: {
      fontSize: 16,
      color: 'white',
      fontWeight: 300
    },
    placeholder: {
      position: 'absolute',
      left: 2,
      fontSize: 16,
      color: 'white'
    },
    paper: {
      position: 'absolute',
      zIndex: 1,
      marginTop: theme.spacing.unit,
      left: 0,
      right: 0,
      cursor: 'pointer'
    }
  };
};

function NoOptionsMessage(props) {
  return _react["default"].createElement(_Typography["default"], _extends({
    color: "textSecondary",
    className: props.selectProps.classes.noOptionsMessage
  }, props.innerProps), props.children);
}

function inputComponent(_ref) {
  var inputRef = _ref.inputRef,
      props = _objectWithoutProperties(_ref, ["inputRef"]);

  return _react["default"].createElement("div", _extends({
    ref: inputRef
  }, props));
}

function Control(props) {
  return _react["default"].createElement(_styles.MuiThemeProvider, {
    theme: theme
  }, _react["default"].createElement(_TextField["default"], _extends({
    fullWidth: true,
    InputProps: {
      disableUnderline: props.selectProps.textFieldProps.disableUnderline,
      inputComponent: inputComponent,
      inputProps: _objectSpread({
        className: props.selectProps.classes.input,
        inputRef: props.innerRef,
        children: props.children
      }, props.innerProps)
    }
  }, props.selectProps.textFieldProps)));
}

function Option(props) {
  return _react["default"].createElement(_MenuItem["default"], _extends({
    buttonRef: props.innerRef,
    selected: props.isFocused,
    component: "div",
    style: {
      fontWeight: props.isSelected ? 300 : 400
    }
  }, props.innerProps), props.children);
}

function Placeholder(props) {
  return _react["default"].createElement(_Typography["default"], _extends({
    color: "textSecondary",
    className: props.selectProps.classes.placeholder
  }, props.innerProps), props.children);
}

function SingleValue(props) {
  return _react["default"].createElement(_Typography["default"], _extends({
    className: props.selectProps.classes.singleValue
  }, props.innerProps), props.children);
}

function ValueContainer(props) {
  return _react["default"].createElement("div", {
    className: props.selectProps.classes.valueContainer
  }, props.children);
}

function Menu(props) {
  return _react["default"].createElement(_Paper["default"], _extends({
    square: true,
    className: props.selectProps.classes.paper
  }, props.innerProps), props.children);
}

var components = {
  Control: Control,
  Menu: Menu,
  NoOptionsMessage: NoOptionsMessage,
  Option: Option,
  Placeholder: Placeholder,
  SingleValue: SingleValue,
  ValueContainer: ValueContainer
};

var AppSelect = /*#__PURE__*/function (_React$Component) {
  _inherits(AppSelect, _React$Component);

  function AppSelect() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, AppSelect);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(AppSelect)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "state", {
      selectedOption: null,
      items: []
    });

    return _this;
  }

  _createClass(AppSelect, [{
    key: "handleChange",
    value: function handleChange(option) {
      var _this2 = this;

      this.setState({
        selectedOption: option
      }, function () {
        if (_this2.props.handler) {
          _this2.props.handler.handleInputChange(_this2.props.name, _this2.props.getOptionValue(option));
        }

        _this2.props.onChange(_this2.props.getOptionValue(option));
      });
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this._loadItems();
    }
    /**
      * Load items
      */

  }, {
    key: "_loadItems",
    value: function () {
      var _loadItems2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _this3 = this;

        var selectedOption, results, _selectedOption, items;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (this.props.model) {
                  _context.next = 6;
                  break;
                }

                if (!this.props.options) {
                  _context.next = 6;
                  break;
                }

                selectedOption = null;

                if (this.props.value) {
                  selectedOption = this.props.options.find(function (x) {
                    return _this3.props.getOptionValue(x.id) == _this3.props.value;
                  });
                }

                this.setState({
                  items: this.props.options,
                  selectedOption: selectedOption
                });
                return _context.abrupt("return");

              case 6:
                ; // Show loader

                this._loadingOn();

                _context.prev = 8;
                _context.next = 11;
                return this._getModel().fetchFlat();

              case 11:
                results = _context.sent;
                _selectedOption = null;

                if (this.props.value) {
                  _selectedOption = results.find(function (x) {
                    return _this3.props.getOptionValue(x.id) === _this3.props.value;
                  });
                }

                items = results;

                if (this.props.empty) {
                  items = [{
                    id: '',
                    name: typeof this.props.empty === 'string' ? this.props.empty : '- any -'
                  }].concat(_toConsumableArray(items));
                }

                this.setState({
                  items: items,
                  selectedOption: _selectedOption
                });
                _context.next = 21;
                break;

              case 19:
                _context.prev = 19;
                _context.t0 = _context["catch"](8);

              case 21:
                setTimeout(function () {
                  _this3._loadingOff();
                }, 100);

              case 22:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[8, 19]]);
      }));

      function _loadItems() {
        return _loadItems2.apply(this, arguments);
      }

      return _loadItems;
    }()
    /**
    * Get model
    */

  }, {
    key: "_getModel",
    value: function _getModel() {
      if (this.model) return this.model;
      this.model = new this.props.model();
      return this.model;
    }
    /**
    * Loading off
    */

  }, {
    key: "_loadingOn",
    value: function _loadingOn() {
      this.setState({
        loading: true
      });
    }
    /**
     * Loading on
     */

  }, {
    key: "_loadingOff",
    value: function _loadingOff() {
      this.setState({
        loading: false
      });
    }
  }, {
    key: "getValidationError",
    value: function getValidationError() {
      var _this4 = this;

      var messages = [];
      if (!this.props.handler) return messages;
      this.props.handler.getErrors().filter(function (x) {
        return x.field === _this4.props.name;
      }).forEach(function (error) {
        return messages.push(error.message);
      });

      if (messages.length === 0) {
        return null;
      }

      return _react["default"].createElement("div", {
        className: "validation-message",
        key: this.props.name + '-error'
      }, messages.join("<br/>"));
    }
  }, {
    key: "render",
    value: function render() {
      var _this5 = this;

      var _this$props = this.props,
          classes = _this$props.classes,
          theme = _this$props.theme;
      var validationError = this.getValidationError();
      return (// <div className='input-group' style={{position: 'relative', width: '100% !important'}}>
        _react["default"].createElement("span", {
          style: {
            position: 'relative',
            margin: '20px 0'
          }
        }, _react["default"].createElement(_reactSelect["default"], {
          textFieldProps: this.props.textFieldProps,
          classes: classes,
          options: this.state.items,
          components: components,
          value: this.state.selectedOption,
          onChange: function onChange(option) {
            return _this5.handleChange(option);
          },
          placeholder: this.props.placeholder,
          getOptionValue: function getOptionValue(option) {
            return _this5.props.getOptionValue(option);
          },
          getOptionLabel: function getOptionLabel(option) {
            return _this5.props.getOptionLabel(option);
          }
        }), validationError) //  </div>

      );
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      var stateChange = {};

      if (props.value) {
        var selectedOption = state.items.find(function (x) {
          return props.getOptionValue(x) === props.value;
        });
        stateChange.selectedOption = selectedOption;
      } else {
        stateChange.selectedOption = null;
      }

      if (props.options) {
        stateChange.items = props.options;
      }

      return stateChange;
    }
  }]);

  return AppSelect;
}(_react["default"].Component);

AppSelect.propTypes = {
  classes: _propTypes["default"].object.isRequired,
  theme: _propTypes["default"].object.isRequired
};
AppSelect.defaultProps = {
  onChange: function onChange() {},
  getOptionValue: function getOptionValue(option) {
    return option.id;
  },
  getOptionLabel: function getOptionLabel(option) {
    return option.name;
  }
};

var _default = (0, _styles.withStyles)(styles, {
  withTheme: true
})(AppSelect);

exports["default"] = _default;